export const stripAccolades = (value: string | undefined) => {
  if (!value) return '';
  return value.replace('{', '').replace('}', '');
};
